import { Outlet } from 'react-router-dom'
import { useTaxiparkQueryParams } from '~/shared/lib/useTaxiparkQueryParams'
import { NotFound } from '~/shared/ui/NotFound'

export function ProtectedRegistrationPage() {
  const { taxiparkIdQuery } = useTaxiparkQueryParams()

  if (!taxiparkIdQuery) return <NotFound message='Некорректный таксопарк' />

  return <Outlet />
}
